import React from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  useTheme,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DeleteDistributionUser = ({
  open,
  onClose,
  onConfirm,
  user,
  loading = false,
  isDistributionList = false,
}) => {
  const theme = useTheme();
  const navbarBackground = theme?.palette?.navbar?.main || theme?.palette?.background?.default || '#f5f5f5';

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "100vw", sm: "50vw", md: "35vw" },
    bgcolor: "background.paper",
    boxShadow: 0,
    borderRadius: 2,
  };

  const userName = user?.userId ? `${user.userName || user.username}` : user?.email || user?.name || 'this item';
  
  const getTitle = () => {
    return isDistributionList ? "Delete Distribution List" : "Confirm Removal";
  };

  const getMessage = () => {
    if (isDistributionList) {
      return `Are you sure you want to delete "${userName}"? This will remove it from any collections it is shared with.`;
    }
    return `Are you sure you want to remove ${userName} from this distribution list?`;
  };

  const getButtonText = () => {
    return isDistributionList ? "Delete" : "Remove";
  };

  if (!user) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onClose}
      aria-labelledby="delete-user-dialog-title"
      aria-describedby="delete-user-dialog-description"
    >
      <Box sx={modalStyle}>
        <Box sx={{ p: 4 }}>
          <Typography
            variant="h4"
            component="div"
            color="#406da4"
            fontWeight="600"
          >
            {getTitle()}
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            disabled={loading}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="body1" sx={{ mt: 2 }}>
            {getMessage()}
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: "secondary.main",
            display: "flex",
            justifyContent: "space-between",
            gap: 5,
            px: 5,
            py: 3,
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            disabled={loading}
            sx={{ width: "45%", textTransform: "none", borderColor: "#406da4" }}
          >
            <Typography variant="h6" sx={{ color: "#406da4" }}>
              Cancel
            </Typography>
          </Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            sx={{
              width: "45%",
              textTransform: "none",
              backgroundColor: "#406da4",
              display: "flex",
              gap: 1,
            }}
          >
            {loading && <CircularProgress size={20} />}
            <Typography variant="h6">{getButtonText()}</Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteDistributionUser;
